/* src/app/modules/portal/components/component-overview/overview.component.scss */
:host {
  display: block;
  height: 100%;
}
.component-side {
  max-width: 750px;
  width: 750px;
}
.img-column {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 16px;
}
.leftBorder {
  border-left: solid;
  border-left-width: thick;
}
.componentExpand {
  cursor: pointer;
}
.grid {
  display: grid;
  grid-template-columns: 60% 40%;
}
.gridContainer {
  transition: height 0.3s ease;
  overflow-x: hidden;
}
.groups {
  position: relative;
  gap: 1.5rem;
  display: flex;
  flex-direction: column;
}
.rightAlign {
  position: absolute;
  right: 20px;
}
.expand-button {
  width: 100%;
  margin-top: 0.5rem;
  display: flex;
  cursor: pointer;
}
.expand-button sh-icon {
  margin-left: auto;
}
.expand-button sh-text {
  width: fit-content;
}
.group {
  max-height: 0px;
  transition: max-height var(--transition-time);
  overflow: hidden;
}
.group.expanded {
  max-height: 100%;
}
.group .title {
  margin-bottom: 0.5rem;
  margin-top: 1rem;
  font-weight: 500;
}
.group .components {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
  column-gap: 1rem;
}
.group .components .item {
  color: initial;
  text-decoration: none;
  width: calc(33.3333333333% - 1rem);
  height: 2.5rem;
  background: rgba(235, 235, 235, 0.6);
  font: var(--title-1);
  display: flex;
  align-items: center;
  padding: 0.5rem;
  box-sizing: border-box;
  overflow: hidden;
}
.group .components .item sh-icon {
  margin-right: 0.5rem;
}
.group .components .item .layout {
  display: flex;
  overflow: hidden;
  flex-direction: column;
}
.group .components .item .layout span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.group .components .item .info {
  font-weight: 400;
}
.group .components .item:hover {
  background: #e6e6e6;
}
.group .components .item[icon=error] {
  background: rgba(var(--functional-red), var(--opacity-5));
}
.group .components .item[icon=warning] {
  background: rgba(var(--functional-yellow), var(--opacity-5));
}
.group .components .item[icon=success] sh-icon {
  display: none;
}
:host([cols="1"]) .components .item {
  width: 100%;
}
:host([cols="2"]) .components .item {
  width: calc(50% - 0.5rem);
}
:host([cols="3"]) .components .item {
  width: calc(33.3333333333% - 1rem);
}
app-lastdatasourcerefresh {
  margin: auto;
}
.data-status {
  display: flex;
}
@media (max-width: 650px) {
  .popover {
    position: fixed;
    left: 50%;
    bottom: 50%;
    height: 100%;
  }
}
@media (min-width: 650px) {
  .popover {
    width: 379px;
    height: auto;
    max-height: 156px;
  }
}
.show-details-button {
  margin-block: 1.5rem;
  margin-inline: auto 0.5rem;
}
.iframe-container {
  transform-origin: 0 0;
  width: 100%;
  height: 100%;
  border: none;
  background: white;
  display: block;
}
.zoom-controls button {
  width: 32px;
  height: 32px;
  font-size: 20px;
  border-radius: 5px;
  border: none;
  background: #333;
  color: white;
}
.zoom-controls button:hover {
  background: #555;
}
.iframe-wrapper {
  width: 100%;
  height: 500px;
  overflow: hidden;
  position: relative;
  border-radius: 4px;
  border: 2px solid #ccc;
  box-sizing: border-box;
}
.iframe-scroll {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.zoom-controls {
  position: absolute;
  bottom: 12px;
  right: 12px;
  display: flex;
  gap: 6px;
  z-index: 3;
}
.fullscreen {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  gap: 6px;
  z-index: 3;
}
iframe {
  display: block;
  box-sizing: border-box;
}
.background-gray {
  background-color: lightgray;
}
/*# sourceMappingURL=overview.component.css.map */
